import type { FC } from 'react'

import { useAtomValue } from 'jotai'

import { useCountdown } from '@/shared/lib/use-countdown'

import type { Rundown } from '~shared/rundown/rundown'

import { getNowAtom } from '../../store/runner.store.js'
import formatTimeOfDay from '../../utils/formatTimeOfDay.js'
import formatTimezone from '../../utils/formatTimezone.js'

type CurrentTimeOfDayProps = {
  timezone?: string
  omitSeconds?: boolean
  showTimezone?: boolean
  todDisplayFormat?: Rundown['settings']['todDisplayFormat']
}

export const CurrentTimeOfDay: FC<CurrentTimeOfDayProps> = ({
  timezone,
  omitSeconds = false,
  showTimezone = false,
  todDisplayFormat,
}) => {
  const getNow = useAtomValue(getNowAtom)

  useCountdown()

  const formattedTod = formatTimeOfDay(getNow(), {
    timezone,
    seconds: omitSeconds ? 'never' : 'always',
    format: todDisplayFormat,
  })

  if (timezone && showTimezone)
    return `${formattedTod} (${formatTimezone(timezone, 'abbr')})`

  return formattedTod
}
